<template>
<div class="perusahaan">
               
  <vue-perfect-scrollbar class="chat-history--scrollbar">
    <v-divider></v-divider>
    <v-list two-line class="chat-contact--list">

      <!-- Table Start -->

      <v-flex lg12 md12>
        <v-toolbar card color="white">
          <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Type something"
          v-model="search"
          hide-details
          class="hidden-sm-and-down"
          ></v-text-field>

          <v-btn color="primary" @click="gotoTambahkanFeedback"><v-icon>add</v-icon><h5>Tambahkan Feedback</h5></v-btn>
     
        </v-toolbar>
  
        <v-divider></v-divider>
  
        <v-data-table
          :headers="complex.headers"
          :search="search"
          :items="complex.items"
          :rows-per-page-items="[15,25,50,{text:'All','value':-1}]"
          class="elevation-1 data-fonts"
          item-key="name"
          v-model="complex.selected"
          >
          <template slot="items" slot-scope="props">
            <td class="data-fonts">{{ props.item.nama }}</td>
            <td class="data-fonts">{{ props.item.instansi }}</td>
            <td class="data-fonts">{{ props.item.email }}</td>
            <td class="data-fonts">{{ props.item.feedback }}</td>
          </template>
        </v-data-table>
      </v-flex>  

      <!-- Table End -->
      
    </v-list>  
  </vue-perfect-scrollbar>  
</div>
</template>

<script>
import { getFeedback } from '@/api/feedback2';
import { Items as Users } from '@/api/feedback2';

import VCircle from '@/components/circle/VCircle';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import VWidget from '@/components/VWidget';

export default {
  components: {
    VuePerfectScrollbar,
    VCircle,
    VWidget
  },

  data: () => ({ 
  }),

  data () {
    return {
      search: '',
      complex: {
        selected: [],
        headers: [
          {
            text: 'Nama',
            value: 'nama'
          },
          {
            text: 'Instansi',
            value: 'instansi'
          },
          {
            text: 'Email',
            value: 'email'
          },
          {
            text: 'Kesan dan Pesan',
            value: 'feedback'
          },
        ],
        items: Users
      }
    };
  },

  computed: {
    users () {
      return getFeedback();
    }
  },

  methods: {

    initialize(){
      this.items = Users;
      console.log("Cek Items : ", this.items);
    },

    deleteItem (item) {
      // const index = this.items.indexOf(item);
      console.log("Item Succesfully Deleted");
    },

    cekDetailKomoditas (id) {
      // window.getApp.$emit('APP_KOMODITAS_LOGISTIK');
      // return '/edit-kontrak/' + id;
    },

    gotoTambahkanFeedback(){
      window.getApp.$emit('APP_TAMBAHKAN_FEEDBACK');
    },

    firstLetter (name) {
      return name.charAt(0);
    },

    userStatusColor (item) {
      return (item.active) ? 'green' : 'grey';
    }    
  }  
};
</script>

<style scoped>
  .data-fonts{
    font-size: 1em;
  }
</style>
